import fetch from 'lib/fetch'

export const CREATE_TOKEN = 'CREATE_TOKEN'
export const CREATED_TOKEN = 'CREATED_TOKEN'
export const CREATE_TOKEN_ERROR = 'CREATE_TOKEN_ERROR'

export const FETCH_TOKENS = 'FETCH_TOKENS'
export const FETCHED_TOKENS = 'FETCHED_TOKENS'
export const FETCH_TOKENS_ERROR = 'FETCH_TOKENS_ERROR'

export const REVOKE_TOKEN = 'REVOKE_TOKEN'
export const REVOKED_TOKEN = 'REVOKED_TOKEN'
export const REVOKE_TOKEN_ERROR = 'REVOKE_TOKEN_ERROR'

export function createToken (workspaceSlug, data) {
  return {
    types: {
      request: CREATE_TOKEN,
      receive: CREATED_TOKEN,
      failure: CREATE_TOKEN_ERROR
    },
    payload: { workspaceSlug, data },
    callAPI: function () {
      return fetch(`/api/workspaces/${workspaceSlug}/tokens`, {
        method: 'POST',
        body: JSON.stringify(data)
      })
      .then((res) => {
        if (!res.ok) {
          throw new Error('Unable to create token')
        }
        return res.json()
      })
    }
  }
}

export function fetchTokens (workspaceSlug) {
  return {
    types: {
      request: FETCH_TOKENS,
      receive: FETCHED_TOKENS,
      failure: FETCH_TOKENS_ERROR
    },
    payload: { workspaceSlug },
    callAPI: function () {
      return fetch(`/api/workspaces/${workspaceSlug}/tokens`)
      .then((res) => {
        if (!res.ok) {
          throw new Error('Unable to fetch tokens')
        }
        return res.json()
      })
      .then(result => result.keys)
    }
  }
}

export function revokeToken (workspaceSlug, accessKey) {
  return {
    types: {
      request: REVOKE_TOKEN,
      receive: REVOKED_TOKEN,
      failure: REVOKE_TOKEN_ERROR
    },
    payload: { workspaceSlug, accessKey },
    callAPI: function () {
      return fetch(`/api/workspaces/${workspaceSlug}/tokens/revoke`, {
        method: 'POST',
        body: JSON.stringify({ accessKey })
      })
      .then((res) => {
        if (!res.ok) {
          throw new Error('Unable to revoke token')
        }
        return res.json()
      })
      .then(() => {
        // temporary
        window.location.reload()
      })
    }
  }
}



// WEBPACK FOOTER //
// ./actions/tokens.js